// 12-hour time picker for an "HH:MM" (24h) value
export function TimePick({ value, onChange, testid, label }) {
  const [h24, m] = (value || "00:00").split(":").map(Number);
  const h12 = h24 % 12 || 12, pm = h24 >= 12;
  const set = (h, mm, p) => onChange(`${String((h % 12) + (p ? 12 : 0)).padStart(2, "0")}:${String(mm).padStart(2, "0")}`);
  return (
    <span className="tpick" role="group" aria-label={label} data-testid={testid}>
      <select className="fld sm" aria-label={`${label} hour`} value={h12} onChange={(e) => set(Number(e.target.value), m, pm)} data-testid={`${testid}-hour`}>
        {Array.from({ length: 12 }, (_, i) => i + 1).map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
      <select className="fld sm" aria-label={`${label} minute`} value={m} onChange={(e) => set(h12, Number(e.target.value), pm)} data-testid={`${testid}-minute`}>
        {Array.from({ length: 60 }, (_, i) => i).map((x) => <option key={x} value={x}>{String(x).padStart(2, "0")}</option>)}
      </select>
      <select className="fld sm" aria-label={`${label} am or pm`} value={pm ? "pm" : "am"} onChange={(e) => set(h12, m, e.target.value === "pm")} data-testid={`${testid}-ampm`}>
        <option value="am">am</option><option value="pm">pm</option>
      </select>
    </span>
  );
}
